import { Icon } from "@/components";
import React from "react";

interface UpdateStepButtonProps {
  onClick: () => void;
}

export function UpdateStepButton({ onClick }: UpdateStepButtonProps) {
  return (
    <div
      role="button"
      onClick={onClick}
      className="d-flex gap-2 align-items-center"
      style={{ color: "var(--bs-secondary)" }}
    >
      <Icon name="pencil" size={16} color="var(--bs-secondary)" />
      Update
    </div>
  );
}
